import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { formatDate } from '@common/helpers';

import './promotion-date-label.scss';

type Alignment = 'left' | 'right';

type FontSize = 'small' | 'medium';

interface PromoDateLabelProps {
    expirationDate: string;
    align?: Alignment;
    fontSize?: FontSize;
}

const PromotionDateLabel = ({
    expirationDate,
    align = 'left',
    fontSize = 'medium',
}: PromoDateLabelProps): JSX.Element => {
    const { t } = useTranslation();

    const promotionDate = formatDate(new Date(expirationDate), '/');

    return (
        <label
            data-testid="promotion-date-label"
            className={classNames('promotion-date-label', {
                'promotion-date-label--left': align === 'left',
                'promotion-date-label--right': align === 'right',
                'promotion-date-label--small': fontSize === 'small',
                'promotion-date-label--medium': fontSize === 'medium',
            })}
        >{`${t('PRICING_AREA.PROMOTION_END_DATE')}  ${promotionDate}`}</label>
    );
};

export default PromotionDateLabel;
